import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './designers.css';
import bg1 from '../assets/image81.png';
import bg2 from '../assets/bg2image83.png';
import bg3 from '../assets/bg3image93.png';
import c1 from '../assets/bbb1Group 48.png';
import c2 from '../assets/bbb2.png';
import c3 from '../assets/bbb3.png';

import c4 from '../assets/c4Group 47.png';
import c5 from '../assets/c5Group 52.png';
import c6 from '../assets/c6Group 51.png';

import c7 from '../assets/c7Group 54.png';
import c8 from '../assets/c7Group53.png';
import c9 from '../assets/c9Group55.png';

import Nav from './../components/layout/nav';

const slides = [
  {
    id: 0,
    name: "OMAR KAMEL",
    style: "Avant-Garde Luxury",
    location: "Cairo",
    year: "2026",
    bio: "A visionary Egyptian designer blending futuristic tailoring with bold cultural silhouettes.",
    bg: bg1,

    objects: {
      c1: c1,
      c2: c2,
      c3: c3
    }
  },

  {
    id: 1,
    name: "LAYLA HASSAN",
    style: "Modern Streetwear",
    location: "Alexandria",
    year: "2026",
    bio: "Known for elevated streetwear aesthetics inspired by Egyptian architecture and youth culture.",
    bg: bg2,

    objects: {
      c1: c4,
      c2: c5,
      c3: c6
    }
  },

  {
    id: 2,
    name: " NOUR EL SHERBINY",
    style: "Minimal Couture",
    location: "Giza",
    year: "2026",
    bio: "Combines minimalism with dramatic runway structure and monochrome identity.",
    bg: bg3,

    objects: {
      c1: c7,
      c2: c8,
      c3: c9
    }
  }
];

const Designers = () => {

  const navigate = useNavigate();

  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prev = () => {
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const slide = slides[index];

  return (
    <section>

      <div className="hcontainer designerspage">

        <div className="homee">

          <div
            className="ddbackgroundimage"
            style={{
              backgroundImage: `url(${slide.bg})`
            }}
          >
            <div className="arrow left" onClick={prev}>
              ‹
            </div>

            <div className="arrow right" onClick={next}>
              ›
            </div>
            <h6 className="DDEFW">
              Egypt Fashion Week
            </h6>
            <h6 className='designerssh5'>Designers</h6>
            <h6 className="ddddtitle">
              {slide.name}
            </h6>
            <img src={slide.objects.c1} className="concreate1" alt="" />
            <img src={slide.objects.c2} className="concreate2" alt="" />
            <img src={slide.objects.c3} className="con4" alt="" />
            <button
              className="learnmorebt"
              onClick={() =>
                navigate('/designerdetails', {
                  state: slide
                })
              }
            >
              Learn More
            </button>

          </div>

          <Nav />

        </div>

      </div>

    </section>
  );
};

export default Designers;